const countForTitle = (count: number): boolean => count > 0;

const countedTitle = (title: string, count: number): string => countForTitle(count) ? `${title} (${count})` : title;

export {countForTitle, countedTitle};
